import { NODE_ENV } from '@/constants/nodeEnv';
import { getEnv } from '@/utils/env';
import { PAGES } from '@/constants/pages';
import { UndecoratedProfile } from '@flemingmetrics/api-client';

const BASE_URL = 'angelclinicians.com';
const LOCAL_URL = 'http://localhost';

export const getApiUrl = () => {
  return getUrl(3000, 'api', '/v1');
};

export const getAuthUrl = () => {
  return getUrl(4100, 'auth');
};

function getUrl(port: number, subdomain: string, path: string = '') {
  const env = getEnv();
  switch (env) {
    case NODE_ENV.DEVELOPMENT:
      return `${LOCAL_URL}:${port}${path}`;
    case NODE_ENV.TESTING:
      return `https://${subdomain}.testing.${BASE_URL}${path}`;
    case NODE_ENV.PRODUCTION:
      return `https://${subdomain}.${BASE_URL}${path}`;
    default:
      throw Error(`Unrecognized environment: "${env}"`);
  }
}

export const getAvatarUrl = (profile: UndecoratedProfile) => {
  return `${getApiUrl()}/profiles/${profile.id}/avatar?key=${encodeURIComponent(profile.avatarUrl!)}`;
};

export const getCompanyUrl = (companyId?: number) => {
  return companyId ? `${PAGES.COMPANIES}/${companyId}` : PAGES.COMPANIES;
};

export const getInvestorUrl = (investorId?: number) => {
  return investorId ? `${PAGES.INVESTORS}/${investorId}` : PAGES.INVESTORS;
};
